const img = require('./id_card_l_active.png'); export default img;